import React, { useState } from 'react';
import { Button, Modal, Form, Input, InputNumber, DatePicker } from 'antd';
import SelectSearchInput from '../../utils/components/selectSearchInput';
import moment from 'moment'
import axios from '../../services/axios'
interface Values {
  title: string;
  description: string;
  modifier: string;
}

interface CollectionCreateFormProps {
  visible: boolean;
  onCreate: (values: Values) => void;
  onCancel: () => void;
  clients: any[];
  devises: any[];
  setClientVisible: () => void
}

const CollectionCreateForms: React.FC<CollectionCreateFormProps> = ({
  visible,
  onCreate,
  onCancel,
  clients,
  devises,
  setClientVisible
}) => {
  const [form] = Form.useForm();
  React.useEffect(() => {
    console.log('monted');
  }, [])
  const onReset = () => {
    form.resetFields();
  }
  const config = {
    rules: [{ type: 'object' as const, required: true, message: 'Please select time!' }],
  };

  const onChange = (name: string, value: any) => {
    form.setFieldsValue({ [name]: value })
  }

  const onSearch = (val: any) => {
    
  }

  const onMontantChange = (value: number) => {
    // const isValue = typeof value === 'number'
    if (form.getFieldValue('devise_id') && form.getFieldValue('devise_sortie') && form.getFieldValue('taux')) {
      // setShowButton(true);
      getAmountConvert()
    }
    else console.log('error')
  }
  const getAmountConvert = () => {
    const data = {
      "devise_id": form.getFieldValue('devise_id'),
      "devise_sortie": form.getFieldValue('devise_sortie'),
      "montant": form.getFieldValue('montant'),
      "taux": form.getFieldValue('taux'),
    }
    axios.post(`operations/devises/convert`, data)
      .then((response) => {
        form.setFieldsValue({ 'montant_convert': response.data as number })
      }).catch((err) => {
        console.log(err);
      });
  }

  return (
    <Modal
      visible={visible}
      title={<>Effectuer un nouveau Retrait <Button onClick={() => setClientVisible()} type="dashed" className=""> Nouveau Client </Button></>}
      okText="Enregistrer"
      cancelText="annuler"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then(values => {
            form.resetFields();
            onCreate(values);
          })
          .catch(info => {
            console.log('Validate Failed:', info);
          });
      }}
    >
      <Form
        form={form}
        layout="horizontal"
        name="form_in_modal"
      >
        <Form.Item label="Numero reçu" style={{ marginBottom: 0 }} rules={[{ required: true }]}>
          <Form.Item
            name='numero_recu'
            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
          >
            <Input
              placeholder="N° reçu "
            />
          </Form.Item>
          <Form.Item name='date_operation' style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}  >
            <DatePicker format="YYYY-MM-DD" defaultValue={moment()} placeholder="date" style={{ width: '100%' }} />
          </Form.Item>
        </Form.Item>

        <Form.Item name='client_id' label="Clients" rules={[{ required: true }]}>
          <SelectSearchInput
            onChange={(v) => onChange('client', v)}
            data={clients}
            label='prenom'
            label2='nom'
            label3='telephone'
            valueLabel='id'
            onSearch={(value) => onSearch(value)}
            placeholder="sectionnez le client "
          />
        </Form.Item>
        <Form.Item label="Réceveur" style={{ marginBottom: 0 }} rules={[{ required: true }]}>
          <Form.Item
            name='nom_deposant'
            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
          >
            <Input placeholder="nom deposant" />

          </Form.Item>
          <Form.Item
            name='tel_deposant'
            style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
          >
            <Input placeholder="téléphone deposant" />
          </Form.Item>
        </Form.Item>
        <Form.Item name='motif' label="Modif" rules={[{ required: true }]}>
          <Input.TextArea placeholder="motif" />
        </Form.Item>

        <Form.Item label="Devises *" style={{ marginBottom: 0 }} rules={[{ required: true }]}>
          <Form.Item
            name='devise_id'
            rules={[{ required: true }]}
            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
          >
            <SelectSearchInput
              onChange={(v) => onChange('devise_id', v)}
              onSearch={(value) => onSearch(value)}
              label='code'
              valueLabel='code'
              data={devises}
              placeholder="Selectionnez d'entrée "
            />
          </Form.Item>
          <Form.Item
            name='devise_sortie'
            rules={[{ required: true }]}
            style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
          >
            <SelectSearchInput
              onChange={(v) => onChange('devise_sortie', v)}
              onSearch={(value) => onSearch(value)}
              label='code'
              valueLabel='code'
              data={devises}
              placeholder="Selectionnez devise de sortie"
            />
          </Form.Item>
        </Form.Item>

        <Form.Item initialValue={1} name='taux' label="Le taux" rules={[{ required: true }]}>
          <InputNumber
            placeholder="taux"
            style={{ width: '100%' }}
            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={(value: any) => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>

        <Form.Item name='montant' label="Montant" rules={[{ type: 'number', required: true }]}>
          <InputNumber
            onChange={(value: any) => onMontantChange(value)}
            placeholder="Montant"
            style={{ width: '100%' }}
            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={(value: any) => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>

        <Form.Item
          name='montant_convert'
          label="M.Converti"
        >
          <InputNumber
            disabled
            placeholder="Montant converti"
            style={{ width: '100%' }}
            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={(value: any) => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item initialValue='retrait' name='type_operation' noStyle>
          <Input type="hidden" />
        </Form.Item>

      </Form>
    </Modal>
  );
};

export default CollectionCreateForms;